import { createFileRoute } from "@tanstack/react-router";
import { FlowCanvas } from "@/app/components/flow/FlowCanvas";
import { FlowSidebar } from "@/app/components/flow/FlowSidebar";
import { useDataSync } from "@/app/hooks/useDataSync";

export const Route = createFileRoute("/flow")({
  component: FlowPage,
});

function FlowPage() {
  // Ensure data is loaded when accessing flow page directly
  useDataSync();

  return (
    <div className="h-[calc(100vh-84px)] w-full bg-stone-50 flex">
      {/* Main flow canvas */}
      <div className="flex-1 relative">
        <FlowCanvas />

        {/* Header overlay */}
        <div className="absolute top-4 left-4 z-40 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-sm border border-stone-200">
          <h1 className="text-lg font-semibold text-stone-900">Flow View</h1>
          <p className="text-sm text-stone-600">
            Drag to connect people to scopes • Click nodes for details
          </p>
        </div>
      </div>

      {/* Sidebar for node details */}
      <FlowSidebar />
    </div>
  );
}
